import { useLayoutEffect, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";

interface ScrollbarInfo {
  hasYScrollbar: boolean;
  yScrollbarWidth: number;
}

export function useScrollbarInfo(): ScrollbarInfo {
  const [scrollInfo, setScrollInfo] = useState({
    hasYScrollbar: false,
    yScrollbarWidth: 0,
  });

  // Add padding when search bar exists/does not exist so appbar does not shift on the width changes
  useLayoutEffect(() => {
    function markIfScrollbarIsPresent(bodyElement: HTMLElement): void {
      const contentOverflows =
        bodyElement.scrollHeight > bodyElement.clientHeight;

      if (bodyElement.style.overflowY === "hidden" || !contentOverflows) {
        setScrollInfo((prev) => ({ ...prev, hasYScrollbar: false }));
      } else if (contentOverflows) {
        const yScrollbarWidth = window.innerWidth - bodyElement.clientWidth;
        setScrollInfo({ hasYScrollbar: true, yScrollbarWidth });
      }
    }

    const styleObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutationRecord) {
        const bodyElement = mutationRecord.target as HTMLBodyElement;
        markIfScrollbarIsPresent(bodyElement);
      });
    });

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const resizeObserver = new ResizeObserver(([entry]) => {
      if (entry && entry.target && entry.target instanceof HTMLElement) {
        markIfScrollbarIsPresent(entry.target);
      }
    });

    const target = document.querySelector("body");

    if (target) {
      // Run for initial mount and then let observer take over
      markIfScrollbarIsPresent(target);
      // Observes style changes made to the body element
      styleObserver.observe(target, {
        attributes: true,
        attributeFilter: ["clientWidth"],
      });
      resizeObserver.observe(target);
    }
    return () => {
      styleObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return scrollInfo;
}
